import React from "react"
import {createRoot} from "react-dom/client"
import {Router} from "react-router-dom"
import {store} from "./store/store"
import {Provider} from "react-redux"
import {createBrowserHistory} from "history"
import {LmsScreen} from "./LmsScreenPage/LmsScreen"
import "./stylesheets/index.scss"
import {Notifications} from "./features/Notifications"

export const history = createBrowserHistory()

const AppWrapper: React.FC = () => {
    return (
        <div>
            <LmsScreen />
            <Notifications />
        </div>
    )
}

const container = document.getElementById("scholastic-root")
const root = createRoot(container!) // createRoot(container!) if you use TypeScript

const render = () => {
    root.render(
        <Provider store={store}>
            <Router history={history}>
                <AppWrapper />
            </Router>
        </Provider>
    )
}

render()
